<template>
  <div class="spa">
    <div v-if="isLoading" class="d-flex justify-content-center">
      <loader></loader>
    </div>

    <div v-else>
      <div class="row mb-3 justify-content-center">
        <div class="col-xl-12 mb-3 text-center">
          <div class="bg-white p-5 spa-intro">
            <h3 class="mb-4">You can book our most popular treatments</h3>
            <p>
              The full list of treatments can be viewed <a href="">here</a>.
            </p>
            <p>
              Can't book the treatment you want below? Call us on
              <a href="tel:01325729999">01325 729999.</a>
            </p>
          </div>
        </div>
      </div>

      <div class="row justify-content-center" v-if="activeView == 'OVERVIEW'">
        <div class="col-24 col-xl-12 mb-4" v-for="(guest, gI) in guests">
          <div class="bg-white h-100 p-4">
            <h3 class="mb-lg-5 mb-md-4 mb-3">{{ getGuestHeading(guest) }}</h3>

            <div
              class="treatment-selection"
              v-for="(item, ti) in guestTreatments(gI)"
              v-bind:class="guest.treatments.length > 0 ? 'mb-2' : ''"
            >
              <div class="row">
                <div class="col-md-22 col-20 position-relative">
                  <span class="treatment-selection-title">
                    {{ item.selection.treatment.DisplayName }}</span
                  >
                  <span class="treatment-selection-detail"
                    >{{ item.selection.duration.Duration }} minutes</span
                  >
                  <span class="treatment-price"
                    >&pound;{{ item.selection.duration.Price }}</span
                  >
                </div>
                <div class="col-md-2 col-4 text-right">
                  <button
                    v-on:click="onRemoveTreatment(selection)"
                    class="treatment-selection-reset"
                  >
                    Reset
                  </button>
                </div>
              </div>
            </div>

            <button
              v-if="canAddTreatment(guest)"
              class="btn btn--slate-blue btn--add btn--block"
              v-on:click="onSelectAddTreatment(guest)"
            >
              Add Treatment
            </button>
          </div>
        </div>
      </div>

      <div
        class="row justify-content-center treatments"
        v-if="activeView == 'TREATMENTS'"
      >
        <div v-if="isInnerLoading" class="d-flex justify-content-center">
          <loader></loader>
        </div>

        <div v-else>
          <div class="row justify-content-center">
            <div
              class="col-24 col-xl-12"
              v-for="(treatment, index) in treatments"
            >
              <div
                class="bg-white spa-day-treatment-item justify-content-between row w-100 g-0"
              >
                <div class="col-24 col-xl-10 gallery g-0">
                  <single-image-gallery
                    v-bind:images="treatment.Images"
                  ></single-image-gallery>
                </div>
                <div class="col-24 col-xl-13 p-md-4 ps-md-2 p-3 item-wrapper">
                  <h4>{{ treatment.DisplayName }}</h4>

                  <div class="flex-grow-1 d-flex flex-column">
                    <div
                      class="item-description"
                      v-html="treatment.Description"
                      v-bind:class="{ on: treatment.expanded }"
                    ></div>

                    <div
                      class="btn-container d-flex justify-content-start flex-row"
                    >
                      <div
                        class=""
                        v-for="(duration, di) in treatment.Durations"
                      >
                        <button
                          type="button"
                          class="btn btn-treatment"
                          v-bind:disabled="
                            isTreatmentSelected(activeGuest, treatment)
                          "
                          v-bind:class="{
                            on: isDurationSelected(
                              activeGuest,
                              treatment,
                              duration
                            ),
                          }"
                          v-on:click="
                            onSelectTreatment(activeGuest, treatment, duration)
                          "
                        >
                          <span>{{ duration.Duration }}mins</span>
                          <span class="modal-price"
                            >&pound;{{ duration.Price }}</span
                          >
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="row justify-content-center times"
        v-if="activeView == 'TIMES'"
      >
        <div v-if="isInnerLoading" class="d-flex justify-content-center">
          <loader></loader>
        </div>

        <div v-else>
          <div
            class="row justify-content-center calendar"
            v-if="activeTimes && activeTimes.GuestAvailability"
          >
            <div
              v-for="(clientAvailability, cai) in activeTimes.GuestAvailability"
              v-bind:key="cai"
              class="col-24 col-xl-12 mb-4"
            >
              <div class="row mb-4">
                <div class="col-24 text-center">
                  <h3>
                    {{ activeSelection.selection.treatment.DisplayName }} for
                    {{ activeGuest.firstName }}
                  </h3>
                </div>
              </div>
              <div class="p-0 p-lg-2">
                <div class="row mb-4 button-wrapper">
                  <div class="col-12">
                    <button
                      type="button"
                      class="btn btn--block modal-button"
                      v-bind:class="{
                        'modal-button--active':
                          (clientAvailability.timeOfDay == undefined &&
                            defaultTimeOfDay == 'AM') ||
                          clientAvailability.timeOfDay == 'AM',
                      }"
                      v-on:click="onSetTimeOfDay(clientAvailability, 'AM')"
                    >
                      AM
                    </button>
                  </div>
                  <div class="col-12">
                    <button
                      type="button"
                      class="btn btn--block modal-button"
                      v-bind:class="{
                        'modal-button--active':
                          (clientAvailability.timeOfDay == undefined &&
                            defaultTimeOfDay == 'PM') ||
                          clientAvailability.timeOfDay == 'PM',
                      }"
                      v-on:click="onSetTimeOfDay(clientAvailability, 'PM')"
                    >
                      PM
                    </button>
                  </div>
                </div>

                <div
                  class="row times"
                  v-if="
                    (clientAvailability.timeOfDay == undefined &&
                      defaultTimeOfDay == 'AM') ||
                    clientAvailability.timeOfDay == 'AM'
                  "
                >
                  <span
                    class="col-12 col-lg-6 mb-3"
                    v-on:click="onSelection(activeGuest, t)"
                    v-for="(t, ca) in clientAvailability.Periods.AM"
                    v-bind:key="ca"
                  >
                    <span
                      class="time-slot h-100"
                      v-bind:class="{
                        'time-slot--active': isSelected(cai, t),
                        'timeslot--disabled': checkIsDisabled(t),
                      }"
                    >
                      <span class="spa-time">{{ t.DisplayTime }}</span>
                    </span>
                  </span>
                </div>

                <div
                  class="row times"
                  v-if="
                    (clientAvailability.timeOfDay == undefined &&
                      defaultTimeOfDay == 'PM') ||
                    clientAvailability.timeOfDay === 'PM'
                  "
                >
                  <span
                    class="col-12 col-lg-6 mb-3"
                    v-on:click="onSelection(activeGuest, t)"
                    v-for="(t, ca) in clientAvailability.Periods.PM"
                    v-bind:key="ca"
                  >
                    <span
                      class="time-slot h-100"
                      v-bind:class="{
                        'time-slot--active': isSelected(cai, t),
                        'timeslot--disabled': checkIsDisabled(t),
                      }"
                    >
                      <span class="spa-time">{{ t.DisplayTime }}</span>
                    </span>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="g-0 actions">
        <div class="row mt-8 d-flex">
          <div class="col-12 d-flex justify-content-start">
            <button
              class="btn btn--transparent btn--back"
              type="button"
              v-on:click="onClose()"
            >
              Cancel
            </button>
          </div>

          <div
            class="col-12 d-flex justify-content-end"
            v-if="!isLoading && !isInnerLoading && activeView == 'OVERVIEW'"
          >
            <button
              class="btn btn--slate-blue btn--continue d-xl-block"
              type="button"
              v-on:click="onSubmit()"
            >
              Confirm
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import spaapi from "@/shared/api/spa";
import Loader from "@/shared/components/Loader.vue";
import SingleImageGallery from "@/shared/components/SingleImageGallery.vue";
import { store } from "../store/index";
import { _ } from "vue-underscore";
export default {
  name: "SpaAddOnTreatment",
  props: {
    addOn: Object,
    isDay: Boolean,
  },
  components: {
    Loader,
    SingleImageGallery,
  },
  data() {
    return {
      guests: [],
      isLoading: false,
      isInnerLoading: false,
      treatments: [],
      activeView: "OVERVIEW",
      selections: [],
      activeGuest: null,
      activeTimes: null,
      activeSelection: null,
      defaultTimeOfDay: "PM",
    };
  },
  mounted() {
    this.isLoading = true;

    for (let gi = 0; gi < this.search.guests.length; gi++) {
      let guest = this.search.guests[gi];
      this.guests.push({ firstName: guest.firstName, treatments: [] });
    }

    store.dispatch("fetchActivities", { id: this.session.Id }).then((t) => {
      this.onSetTreatments(t);

      this.isLoading = false;
    });
  },
  computed: {
    search() {
      return store.getters.search;
    },
    session() {
      return store.getters.session;
    },
  },
  methods: {
    guestTreatments(index) {
      let guestSelected = this.selections.filter((g) => g.guestIndex == index);

      return guestSelected;
    },

    onSetTreatments(activities) {
      this.treatments = [];

      if (activities != null) {
        var innerTreatments = this.addOn.content.TreatmentGroups[0].Treatments;

        for (let ti = 0; ti < innerTreatments.length; ti++) {
          let treatment = innerTreatments[ti];

          for (let di = 0; di < treatment.Durations.length; di++) {
            let duration = treatment.Durations[di];

            let activity = activities.find(
              (item) => item.Code == duration.Code
            );

            if (activity == undefined || activity == null) {
              treatment.Durations.pop(duration);
            } else {
              duration.Id = activity.ID;
              duration.Duration = activity.Length - activity.Interval;
              duration.Price = activity.StandardPrice;
            }
          }

          if (treatment.Durations != null && treatment.Durations.length) {
            treatment.Durations = _.sortBy(
              treatment.Durations,
              function (item) {
                return item.Duration;
              }
            );
            this.treatments.push(treatment);
          }
        }
      }

      for (let ti = 0; ti < this.treatments.length; ti++) {
        let tr = this.treatments[ti];
        var includedDuration = tr.Durations.find((item) => item.IsIncluded);
        if (includedDuration != null) {
          for (let di = 0; di < tr.Durations.length; di++) {
            let dr = tr.Durations[di];

            dr.PriceDifference = dr.Price - includedDuration.Price;
          }
        }
      }
    },

    onSelectAddTreatment(guest) {
      this.activeView = "TREATMENTS";
      this.activeGuest = guest;
    },

    onSelectTreatment(guest, treatment, duration) {
      let o = this;
      this.isInnerLoading = true;

      let guestIndex = this.guests.indexOf(guest);

      let selectedTreatment = {
        guestIndex,
        selection: {
          treatment,
          duration,
        },
      };

      this.activeSelection = selectedTreatment;

      let selections = this.selections.flatMap((item) => {
        return item.time.TreatmentTimes;
      });

      let payload = {
        SessionId: this.session.Id,
        Date: moment(this.search.date).format("YYYY-MM-DD"),
        GuestRequirements: [
          {
            Activities: [selectedTreatment.selection.duration.Id],
          },
        ],
        FilteredSelections: selections,
      };

      store
        .dispatch("fetchNakedAvailability", payload)
        .then((t) => {
          var filtered = o.filterTimes(t);

          o.activeTimes = filtered;

          o.isInnerLoading = false;
        })
        .catch((e) => {
          console.log(e);

          o.isInnerLoading = false;
        });

      this.activeView = "TIMES";
    },

    onSelection: function (guest, t) {
      if (!t.IsAvailable) {
        return;
      }

      this.activeSelection.time = t;

      this.selections.push(this.activeSelection);

      this.activeGuest = null;
      this.activeSelection = null;
      this.activeTimes = null;

      this.activeView = "OVERVIEW";
    },

    onClose() {
      this.$parent.$emit("close");
    },
    onSubmit() {
      //select items
      //then close
      store.dispatch("selectTreatmentExtras", this.selections).then(() => {
        this.$parent.$emit("close");
      });

      this.trackAddOnSelection(this.selections);
    },
    getGuestHeading(guest) {
      return guest.firstName + "'s treatments";
    },
    canAddTreatment(guest) {
      let index = this.guests.indexOf(guest);

      let treatments = this.guestTreatments(index);

      return treatments.length < 1;
    },
    treatmentNumber(guest) {
      let result = 1;

      if (guest.treatments != undefined) {
        result = guest.treatments.length + 1;
      }

      return result;
    },
    isTreatmentSelected(guest, treatment) {
      let result = false;

      if (guest.treatments != null && guest.treatments.length) {
        for (let ti = 0; ti < guest.treatments.length; ti++) {
          let t = guest.treatments[ti];

          if (t.treatment.Id == treatment.Id) {
            return true;
          }
        }
      }
      return result;
    },

    isDurationSelected(guest, treatment, duration) {
      let result = false;

      if (guest.treatments != null && guest.treatments.length) {
        for (let ti = 0; ti < guest.treatments.length; ti++) {
          let t = guest.treatments[ti];

          if (t.treatment.Id == treatment.Id) {
            if (t.duration.Id == duration.Id) {
              return true;
            }
          }
        }
      }
      return result;
    },
    isSelected(a, t) {
      let guest = this.search.guests[a];
      if (guest !== undefined && guest.startTime !== undefined) {
        return t == guest.startTime;
      }
      return false;
    },
    checkIsDisabled(t) {
      return !t.IsAvailable;
    },
    onSetTimeOfDay(a, timeOfDay) {
      a.timeOfDay = timeOfDay;
    },
    onRemoveTreatment(selection) {
      const index = this.selections.indexOf(selection);
      this.selections.splice(index, 1);
    },
    filterTimes(t) {
      if (t?.GuestAvailability[0]?.Periods != null) {
        let am = t.GuestAvailability[0].Periods.AM;
        if (am != null && am.length) {
          let filteredAm = this.filterPeriod(am);
          t.GuestAvailability[0].Periods.AM = filteredAm;
        }

        let pm = t.GuestAvailability[0].Periods.PM;
        if (pm != null && pm.length) {
          let filteredPm = this.filterPeriod(pm);
          t.GuestAvailability[0].Periods.PM = filteredPm;
        }
      }
      return t;
    },
    filterPeriod(periods) {
      let result = [];

      let guestMaxArrivalTime, bandEnd, bandEndTime, dayEndTime;

      if (this.isDay) {
        guestMaxArrivalTime = _.max(
          this.search.guests.map((item) =>
            moment.utc(item.spaDayArrivalTime.selectedItem.EndDateTime)
          )
        );
        bandEnd = this.search.spaDay.bookingDetails.TimeBands.find(
          (item) => item.BandNumber == this.search.spaDay.Band
        )?.EndTime;

        bandEndTime = moment.utc(bandEnd, "HH:mm");
        dayEndTime = moment
          .utc(this.search.date)
          .add(bandEndTime.hour(), "h")
          .add(bandEndTime.minutes(), "m");
      }

      for (let pi = 0; pi < periods.length; pi++) {
        let period = periods[pi];
        if (!period.IsAvailable) {
          result.push(period);
          continue;
          //Don't need to process it
        }

        var treatmentTimeStart = period.TreatmentTimes[0].StartTime;
        var treatmentTimeEnd = period.TreatmentTimes[0].EndTimeTime;

        let startTime = moment.utc(treatmentTimeStart); // i think we need to remove the duration here..

        let endTime = moment.utc(treatmentTimeEnd);

        if (this.isDay) {
          if (startTime < guestMaxArrivalTime) {
            period.IsAvailable = false;
            period.TreatmentTimes = null;
            result.push(period);
            continue;
          }

          if (endTime > dayEndTime) {
            period.IsAvailable = false;
            period.TreatmentTimes = null;
            result.push(period);
            continue;
          }
        }

        let canInclude = true;
        for (var gi = 0; gi < this.search.guests.length; gi++) {
          let guest = this.search.guests[gi];
          if (guest.spaArrivalTime != null) {
            let startGardenTime = moment.utc(
              guest.spaArrivalTime.StartDateTime
            );
            let endGardenTime = moment.utc(guest.spaArrivalTime.EndDateTime);

            if (
              startTime.isSame(startGardenTime) ||
              startTime.isBetween(startGardenTime, endGardenTime) ||
              endTime.isSame(endGardenTime) ||
              endTime.isBetween(startGardenTime, endGardenTime)
            ) {
              canInclude = false;
              break;
            }
          }
        }
        if (!canInclude) {
          period.IsAvailable = false;
          period.TreatmentTimes = null;
          result.push(period);
          continue;
        }

        //flatten treatments
        let treatmentGuests = this.search.guests.filter(
          (item) => item.startTime?.TreatmentTimes != null
        );

        if (treatmentGuests != null && treatmentGuests.length) {
          let flattenedTreatments = this.search.guests.flatMap(function (item) {
            return item.startTime.TreatmentTimes;
          });

          for (var fi = 0; fi < flattenedTreatments.length; fi++) {
            var fTreatment = flattenedTreatments[fi];

            let fTreatmentStart = moment.utc(fTreatment.StartTime);
            let fTreatmentEnd = moment.utc(fTreatment.EndTime);

            if (
              startTime.isSame(fTreatmentStart) ||
              startTime.isBetween(fTreatmentStart, fTreatmentEnd) ||
              endTime.isSame(fTreatmentEnd) ||
              endTime.isBetween(fTreatmentStart, fTreatmentEnd)
            ) {
              canInclude = false;
              break;
            }
          }

          if (!canInclude) {
            period.IsAvailable = false;
            period.TreatmentTimes = null;
            result.push(period);
            continue;
          }
        }

        period.IsAvailable = true;
        result.push(period);
      }

      return result;
    },

    trackAddOnSelection(addOns) {
      if (this.$gtm.enabled()) {
        let items = [];
        for (let i = 0; i < addOns.length; i++) {
          let main = addOns[i];

          let item = {
            item_id: main.selection.duration.Code,
            item_name: main.selection.treatment.DisplayName,
            item_list_name: "Spa Add On",
            price: main.selection.duration.Price,
          };

          items.push(item);
        }

        window.dataLayer?.push({
          pageURL: "/spa/treatment/add-ons",
          event: "add_to_cart",
          ecommerce: {
            item_list_name: "Spa Add Ons",
            items: items,
          },
        });
      }
    },
  },
};
</script>

<style scoped>
.spa-day-treatment-item {
  min-height: 250px;
  margin-bottom: 20px;
  height: calc(100% - 20px);
}

.treatment-price {
  position: absolute;
  right: 0;
  font-weight: bold;
  top: 0;
}

.spa-day-treatment-item h4 {
  font-size: 24px;
}

.spa-day-treatment-item .gallery {
  height: 250px;
}

.spa .treatments .item-wrapper {
  display: flex;
  flex-direction: column;
  text-align: start;
}

.spa .treatments .item-description {
  white-space: normal;
  overflow: hidden;
  text-overflow: ellipsis;
  height: 15px;
  margin-bottom: 10px;
  flex-grow: 1;
}

.spa .treatments .item-description.on {
  height: auto;
}

.spa .treatments .view-more {
  background: none;
  border: none;
  margin-bottom: 5px;
  display: flex;
  align-self: flex-end;
}

.spa .treatments .modal-content {
  max-width: none;
  height: 100%;
}

.spa .treatments .btn-treatment {
  border: none;
  margin-right: 5px;
  padding: 15px;
  background: #eae5e3;
  text-transform: capitalize;
  min-width: 100px !important;
}

.spa .treatments .btn-treatment:hover {
  color: #fff;
  background: #425260;
}

.spa .treatments .btn-treatment:disabled {
  color: #000;
  cursor: not-allowed !important;
}

.spa .treatments .btn-treatment.on:disabled {
  background: #425260;
  color: #fff;
}

.spa .treatments .treatment-name {
  font-size: 14px;
  display: block;
  margin-bottom: 5px;
  font-weight: bold;
}

.spa .treatments .treatment-duration {
  font-size: 14px;
  display: block;
  font-weight: 300;
}

.spa .treatments .btn-edit {
  border: none;
  background-color: transparent;
  position: absolute;
  right: 0%;
  top: 0%;
  height: 15px;
  text-indent: -9999px;
  width: 15px;
  background-position: center center;
  background-size: 15px 15px;
  background-repeat: no-repeat;
  background-image: url("@/assets/img/booking/edit.svg");
  position: absolute;
  top: 15px;
  right: 15px;
}

.spa .modal-body {
  overflow-y: scroll;
  height: 800px;
}

.spa .treatment-selection {
  padding: 20px;
  border-radius: 2px;
  background-color: #eae5e3;
  color: #333;
  font-size: 14px;
  font-family: Montserrat;
  position: relative;
  margin-bottom: 20px;
}

.spa .treatment-selection-reset {
  text-indent: -9999px;
  position: relative;
  right: 7px;
  top: 3px;
  border: none;
  height: 15px;
  width: 15px;
  background-size: 15px 15px;
  background-position: center center;
  background-repeat: no-repeat;
  background-image: url("@/assets/img/website/modal-close.svg");
  background-color: transparent;
}

.spa .treatment-selection-title {
  font-weight: bold;
  display: block;
}

.spa .treatment-selection-detail {
  font-weight: 300;
}

.spa .treatment-selection ul {
  list-style: none;
  padding: 0;
  margin-bottom: 0;
}

.spa .treatments .spa-intro a {
  font-weight: bold;
  color: #a2905b;
}

.spa .treatments .spa-intro h3 {
  font-size: 24px;
}

.spa .treatments .spa-intro p {
  font-size: 16px;
}

.spa .treatments .spa-intro p:last-of-type {
  margin-bottom: 0;
}

.spa .modal-price {
  display: block;
  margin-top: 5px;
  font-weight: normal;
}

@media (max-width: 991px) {
  .spa .treatments .item-description {
    height: auto;
  }

  .spa .treatment-selection {
    margin-bottom: 0;
  }
}
</style>

<style scoped>
.spa-time {
  display: block;
  font-weight: bold;
}

.time-slot {
  background: white;
  border-radius: 5px;
  margin-bottom: 20px;
  cursor: pointer;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 10px;
}

.time-slot.time-slot--unavailable {
  color: rgba(66, 82, 96, 0.15);
  cursor: not-allowed;
}

.time-slot:not(.time-slot--unavailable):hover,
.time-slot.time-slot--active {
  background-color: #425260;
  color: #fff;
}

.calendar:nth-child(even) .button-wrapper {
  /*     padding-left: 40px;*/
}

.calendar:nth-child(odd) .button-wrapper {
  /*        padding-right: 40px;*/
}

/*    .calendar:nth-child(even) .times {
        padding-left: 40px;
    }*/

@media (min-width: 991px) {
  .calendar:nth-child(odd) .times {
    /*padding-right: 40px;*/
    /*        border-right: solid 1px rgba(53,64,114, 0.2)*/
  }
}

.timeslot {
  cursor: pointer !important;
}

.timeslot--disabled,
.timeslot--disabled:hover {
  background: #ddd !important;
  color: #000 !important;
  cursor: default;
}

.modal-button {
  background-color: #fff;
  position: relative;
  color: #000;
  border-color: #fff;
  margin-bottom: 30px !important;
}

.modal-button:after {
  border-top: 10px solid #fff;
  display: block;
  position: absolute;
  content: " ";
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  z-index: 10;
}

.modal-botton:hover,
.modal-button--active {
  background-color: #425260;
  border-color: #425260;
  color: #fff;
}

.modal-botton:hover,
.modal-button--active:after {
  border-top: 10px solid #425260;
}
</style>
<style scoped>
.spa-total-label {
  font-weight: 300;
  display: block;
  font-size: 16px;
  text-align: center;
}

.spa-total {
  font-weight: bold;
  display: block;
  font-size: 24px;
  text-align: center;
}

.actions {
}
</style>
